import apiClient from './apiClient';

export default {
  fetchInvoices: (lastId = '') => apiClient.get('/invoices', { params: { lastId } }),
  createCryptoPayment: (amount, currency) => apiClient.post('/crypto-payment', { amount, currency }),
  getCryptoPayment: (paymentId) => apiClient.get(`/crypto-payment/${paymentId}`),
  nmiCharge: (paymentToken, amount) => apiClient.post('/nmi/charge', { paymentToken, amount }),
  getBankDetails: () => apiClient.get('/bank-details?v=2'),
};
